import { FC } from "react";
import {
  LocalizationProvider,
  DatePicker,
  DatePickerProps,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

import { Control, Controller, FieldValues } from "react-hook-form";
import FieldGridContainer from "../fieldGridContainer";
import { Dayjs } from "dayjs";

export type ControlledDateFieldProps<TDate extends Dayjs> =
  DatePickerProps<TDate> & {
    control?: Control<FieldValues> | undefined;
    isGridItem?: boolean;
    label: string;
    id: string;
    name: string;
    helperText?: string;
    errorMessage?: string;
    required?: boolean;
  };

const ControlledDateField: FC<ControlledDateFieldProps<any>> = (
  props: ControlledDateFieldProps<any>,
) => {
  const {
    control,
    isGridItem = true,
    label,
    id,
    name,
    helperText = "",
    errorMessage,
    ...otherProps
  } = props;

  if (isGridItem) {
    return (
      <FieldGridContainer>
        <Controller
          name={name ?? ""}
          control={control}
          render={({ field, fieldState }) => {
            const validationMessage =
              errorMessage ?? fieldState.error?.message;
            const hint = `${helperText} [MM/DD/YYYY]`;
            return (
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  {...field}
                  value={field.value || null}
                  onChange={(date) => field.onChange(date)}
                  data-name={id}
                  slotProps={{
                    textField: {
                      variant: "outlined",
                      size: "small",
                      helperText: validationMessage ?? hint,
                      id,
                      error: !!validationMessage,
                    },
                  }}
                  label={label}
                  {...otherProps}
                />
              </LocalizationProvider>
            );
          }}
        />
      </FieldGridContainer>
    );
  }

  return (
    <Controller
      name={name ?? ""}
      control={control}
      render={({ field, fieldState }) => {
        const validationMessage = errorMessage ?? fieldState.error?.message;
        const hint = `${helperText} [MM/DD/YYYY]`;
        return (
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              {...field}
              value={field.value || null}
              onChange={(date) => field.onChange(date)}
              data-name={id}
              slotProps={{
                textField: {
                  variant: "outlined",
                  size: "small",
                  helperText: validationMessage ?? hint,
                  id,
                  error: !!validationMessage,
                },
              }}
              label={label}
              {...otherProps}
            />
          </LocalizationProvider>
        );
      }}
    />
  );
};

export default ControlledDateField;
